import { render } from "./HorizontalBarChart.vue?vue&type=template&id=676042f1&scoped=true"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"

import "./HorizontalBarChart.vue?vue&type=style&index=0&id=676042f1&lang=scss&scoped=true"
import "./HorizontalBarChart.vue?vue&type=style&index=1&id=676042f1&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-676042f1"]])

export default __exports__